import {
  Link,
  ExternalLink,
  Globe,
  Home,
  Book,
  FileText,
  Folder,
  FolderOpen,
  Search,
  HelpCircle,
  Info,
  Settings,
  User,
  Users,
  Mail,
  MessageCircle,
  Phone,
  Calendar,
  Clock,
  Star,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Share,
  Download,
  Upload,
  Cloud,
  Database,
  Server,
  Monitor,
  Smartphone,
  Tablet,
  Camera,
  Video,
  Music,
  Image,
  Map,
  Navigation,
  Compass,
  Flag,
  Award,
  Gift,
  ShoppingCart,
  CreditCard,
  DollarSign,
  TrendingUp,
  TrendingDown,
  BarChart,
  PieChart,
  Activity,
  Zap,
  Sun,
  Moon,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Shield,
  Key,
  Wifi,
  Bluetooth,
  Radio,
  Tv,
  Headphones,
  Speaker,
  Volume,
  VolumeX,
  Play,
  Pause,
  SkipBack,
  SkipForward,
  Rewind,
  FastForward,
  Shuffle,
  Repeat,
  List,
  Grid,
  Columns,
  Rows,
  Layout,
  Sidebar,
  Menu,
  MoreHorizontal,
  MoreVertical,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Move,
  RotateCcw,
  RotateCw,
  ZoomIn,
  ZoomOut,
  Maximize,
  Minimize,
  X,
  Plus,
  Minus,
  Check,
  AlertCircle,
  AlertTriangle,
  AlertOctagon,
  CheckCircle,
  XCircle,
  Lightbulb,
  Sparkles,
} from 'lucide-angular';

// Map of icon names to their Lucide icon components
export const ICON_MAP = {
  link: Link,
  'external-link': ExternalLink,
  globe: Globe,
  home: Home,
  book: Book,
  'file-text': FileText,
  folder: Folder,
  'folder-open': FolderOpen,
  search: Search,
  'help-circle': HelpCircle,
  info: Info,
  settings: Settings,
  user: User,
  users: Users,
  mail: Mail,
  'message-circle': MessageCircle,
  phone: Phone,
  calendar: Calendar,
  clock: Clock,
  star: Star,
  heart: Heart,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  share: Share,
  download: Download,
  upload: Upload,
  cloud: Cloud,
  database: Database,
  server: Server,
  monitor: Monitor,
  smartphone: Smartphone,
  tablet: Tablet,
  camera: Camera,
  video: Video,
  music: Music,
  image: Image,
  map: Map,
  navigation: Navigation,
  compass: Compass,
  flag: Flag,
  award: Award,
  gift: Gift,
  'shopping-cart': ShoppingCart,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'bar-chart': BarChart,
  'pie-chart': PieChart,
  activity: Activity,
  zap: Zap,
  sun: Sun,
  moon: Moon,
  eye: Eye,
  'eye-off': EyeOff,
  lock: Lock,
  unlock: Unlock,
  shield: Shield,
  key: Key,
  wifi: Wifi,
  bluetooth: Bluetooth,
  radio: Radio,
  tv: Tv,
  headphones: Headphones,
  speaker: Speaker,
  volume: Volume,
  'volume-x': VolumeX,
  play: Play,
  pause: Pause,
  'skip-back': SkipBack,
  'skip-forward': SkipForward,
  rewind: Rewind,
  'fast-forward': FastForward,
  shuffle: Shuffle,
  repeat: Repeat,
  list: List,
  grid: Grid,
  columns: Columns,
  rows: Rows,
  layout: Layout,
  sidebar: Sidebar,
  menu: Menu,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevron-down': ChevronDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  move: Move,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  maximize: Maximize,
  minimize: Minimize,
  x: X,
  plus: Plus,
  minus: Minus,
  check: Check,
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'alert-octagon': AlertOctagon,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  lightbulb: Lightbulb,
  sparkles: Sparkles,
} as const;

// Helper function to get the icon component for a given icon name
export function getIconComponent(iconName: string) {
  return ICON_MAP[iconName as keyof typeof ICON_MAP];
}
